import { connect } from 'react-redux'
import WalletBalance, { IWalletBalanceProps } from '../../../components/riders/riderdetails/wallet/WalletBalance'
import { IRiderObject, IStoreState, IUserTopPanelRider } from '../../../types'
import * as riderActions from '../../../state/actions/riders/'

import { BALANCE_TYPES } from '../../../constants/wallet'

interface IProps extends IWalletBalanceProps {
  balanceType: BALANCE_TYPES
  riderId: string
  rider: IUserTopPanelRider | IRiderObject
}

export function mapStateToProps(state: IStoreState, ownProps: IProps): any {
  const rider = ownProps.rider
  const riderWallet = rider && rider.wallet ? rider.wallet.wallet : { balance: 0, bonusBalance: 0 }
  let balance = 0

  switch (ownProps.balanceType) {
    case BALANCE_TYPES.BONUS:
      balance = riderWallet.bonusBalance
      break
    case BALANCE_TYPES.OVERALL:
      balance = riderWallet.balance + riderWallet.bonusBalance
      break
    case BALANCE_TYPES.WALLET:
    default:
      balance = riderWallet.balance
      break
  }

  return {
    ...ownProps,
    rider,
    balance: balance / 100
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderDetails: (riderId: string) => dispatch(riderActions.getRiderPersonalInfo(riderId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletBalance)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/WalletBalance.ts